<template>
    <div v-if="listready" class="wrapper">
        <div class="animated fadeIn">
            <b-card header="<i class='fa fa-align-justify'></i><strong> Afdelingen</strong>">
                <filter-form
                        :bedrijven="bedrijven"
                        :currentFilter="currentFilter"
                        @get-items="getItems">
                </filter-form>
                <br />
                <item-list
                        :items="items"
                        @delete-item="deleteItem"
                        @kopieer-item="kopieerItem">
                </item-list>
            </b-card>
        </div>

        <b-modal title="Verwijderen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Deze afdeling kan niet verwijderd worden! Aan deze afdeling zijn nog andere gegevens gekoppeld. {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/afdeling';
    import FilterForm from './FilterForm';
    import ItemList from './List';

    export default {
        data () {
            return {
                warningModal: false,
                listready: false,
                errormsg: '',
                bedrijven: [],
                items: [],
            };
        },
        computed: {
            currentFilter () {
                const filter = this.$store.getters.afdelingFilter;
                return Object.assign({}, filter);
            },
        },
        created () {
            this.getItems(true);
        },
        methods: {
            getItems (withselect) {
                this.$store.dispatch('saveAfdelingFilter', this.currentFilter);
                api.getListAfdeling(withselect, this.currentFilter.bedrijf,
                    this.currentFilter.zoekstring).then((response) => {
                    if (withselect) {
                        this.bedrijven = response.data.bedrijven;
                        this.bedrijven.unshift({ id: 0, naam: '-- Alle --' });
                    }
                    this.items = response.data.items;
                    this.listready = true;
                });
            },
            deleteItem (id) {
                api.deleteAfdeling(id).then(() => {
                    this.getItems(false);
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            kopieerItem (id) {
                api.kopieerAfdeling(id).then(() => {
                    this.getItems(false);
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'filter-form': FilterForm,
            'item-list': ItemList,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/afdeling/Index.vue